import React, { useEffect, useState } from "react";
import { formadate, formatDate } from "../../_App/Helpers/helpers";
import {
  ProgramFideliteType,
  RemiseType,
} from "../../_App/Types/Entites/RemiseType";
import RemiseFiltre from "./RemiseFiltre";
import {
  currentpage,
  findRemisesByFiltre,
  ListRemises,
  totalPages,
} from "../../_App/Redux/Slices/remise/remiseSlice";
import { useAppSelector } from "../../_App/Redux/hooks";
import PaginationLayout from "../../_Layouts/Pagination/PaginationLayout";

export default function RemiseTable({
  ProgramsFidelites,
  updateFunction,
  desactiveFunction,
  activeFunction,
  t,
  societe_id,
  currentOrg,
  dispatch,
  RemoveFunction,
}: any) {
  const today = new Date();
  const yesterday = new Date(today);
  yesterday.setDate(today.getDate() - 1);
  const [index, setindex] = useState(1);
  const remises = useAppSelector(ListRemises);
  const current_page = useAppSelector(currentpage);
  const totalpages = useAppSelector(totalPages);
  const [Filtre, setFiltre] = useState({
    etat: "tout",
    libelle: "",
    pourcentage1: 0,
    pourcentage2: 0,
    date_fin: formatDate(today),
    date_debut: formatDate(yesterday),
    societe_id: societe_id,
    organisation: "null",
    index: 1,
  });

  useEffect(() => {
    if (currentOrg) {
      setFiltre((prev: any) => ({
        ...prev,
        organisation: currentOrg,
      }));
    }
  }, [currentOrg]);

  useEffect(() => {
    const copie = { ...Filtre };
    copie.index = index;
    setFiltre(copie);
    dispatch(findRemisesByFiltre(copie));
  }, [index]);
  const searchfiltre = () => {
    setindex(1);
    const copie = { ...Filtre };
    copie.index = 1;
    setFiltre(copie);
    dispatch(findRemisesByFiltre(copie));
  };
  return (
    <div>
      <RemiseFiltre
        t={t}
        searchfiltre={searchfiltre}
        setFiltre={setFiltre}
        Filtre={Filtre}
      />
      <div className="table-responsive">
        <table className="table">
          <thead>
            <tr>
              <th>{t("Libelle")}</th>
              <th>{t("Pouçentage")}</th>
              <th>{t("Date début")}</th>
              <th>{t("Date fin")}</th>
              <th>{t("Status")}</th>
              <th colSpan={3}></th>
            </tr>
          </thead>
          <tbody>
            {remises &&
              remises.map((item, index) => (
                <tr key={index}>
                  <td>{item.libelle}</td>
                  <td>{item.percentage}</td>
                  <td>{item.date_debut?.toString().split("T")[0]}</td>
                  <td>{item.date_fin?.toString().split("T")[0]}</td>
                  <td> {item.actif ? "Actif" : "Inactif"} </td>

                  {item.actif ? (
                    <>
                      <td>
                        <span
                          style={{
                            cursor: "pointer",
                            fontSize: "1.5em",
                            marginRight: "10px",
                            color: "green",
                          }}
                          onClick={() => desactiveFunction(item)}
                        >
                          {" "}
                          <i className="fas fa-power-off"></i>
                        </span>
                      </td>
                    </>
                  ) : (
                    <>
                      <td>
                        <span
                          style={{
                            cursor: "pointer",
                            fontSize: "1.5em",
                            marginRight: "10px",
                            color: "red",
                          }}
                          onClick={() => activeFunction(item)}
                        >
                          {" "}
                          <i className="fas fa-power-off"></i>
                        </span>
                      </td>
                      <td></td>
                    </>
                  )}
                  {item.update||item.update ===undefined ? (
                    <td>
                      <span
                        style={{
                          cursor: "pointer",
                          fontSize: "1.5em",
                          marginRight: "10px",
                        }}
                        onClick={() => updateFunction(item)}
                      >
                        <i
                          className="fas fa-edit"
                          style={{ color: "#06958d" }}
                        ></i>
                      </span>
                    </td>
                  ):<td></td>}
                  <td>
                    <span
                      style={{
                        cursor: "pointer",
                        fontSize: "1.5em",
                        marginRight: "10px",
                      }}
                      onClick={() => RemoveFunction(item._id)}
                    >
                      <i
                        className="fas fa-trash-alt"
                        style={{ color: "#06958d" }}
                      ></i>
                    </span>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
      <div className="row layout-spacing">
        <PaginationLayout
          index={index}
          nbrpage={current_page}
          totalpages={totalpages}
          setindex={setindex}
        />
      </div>
    </div>
  );
}
